export function checkProps (prop: string | boolean): boolean {
  return typeof prop === "string" ? true : Boolean(prop);
}